var map = {
	"./customer.js": "DzHK",
	"./manager.js": "j7ut",
	"./otherOrder.js": "HnTh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3pT8";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules ^(?!internals).*\/(?!.*index).*\.js$
// module id = 3pT8
// module chunks = 43